// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Entire Simulation */

[draggable="true"] {
  /*
   To prevent user selecting inside the drag source
  */
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.s-color-map{
  width: calc(255px * 2);
  height: 20px;
  box-shadow: 4px 4px 10px #00000042;
}

.p-simulation-container{
  min-width: -moz-fit-content;
  min-width: fit-content;
  display: flex;
  /* flex-direction: column; */
  justify-content: center;
  align-items: center;
  padding: 2rem;
  margin: 10px 2rem;
  background-color: rgba(124, 124, 124, 0.158);

}

.p-valid-ans{
  border: 2px solid green;
}
.p-invalid-ans{
  border: 2px solid red;
}

/* Control Panel */
.pooling-control-panel-container{
  min-width: 400px;
  padding: 10px;
  background-color: rgb(255, 249, 249);
  box-shadow: 2px 2px 10px #00000042;
  margin: 5px;

}
.pooling-simulation-title{
  background-color: #FFB800;
  border-radius: 5px;
  padding: 2px;
  margin: 5px;
  text-shadow: 3px 3px 3px rgba(226, 223, 223, 0.747);
  box-shadow: 4px 4px 10px #00000042;
  font-size: 20px;
  display: flex;
  justify-content: center;
  font-weight: bolder;
}

.all-select-container{
  display: flex;
  justify-content: center;
  width: calc(100% - 10px);
  margin: 5px;
  padding: 5px;
  background-color: white;

}

.pooling-section{
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;

}

.select-container{
  width: 100%;
  margin: 5px;
}

.p-image-option{
  width: 80px;
  height: 80px;
  margin-right: 5px;
  box-shadow: 2px 2px 5px grey;
}

.p-image-option:hover{
  transform: scale(1.1);
  transition: transform 0.3s ease;
  cursor: pointer;
}

/* Input Pooling Image */

.pooling-result-container{
  min-width: -moz-fit-content;
  min-width: fit-content;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.input-pooling-image{
  box-shadow: 4px 4px 10px grey;
  /* border: 1px solid black; */
}

.p-filter-hovered-area{
  width: 21.0px;
  height: 21.0px;
  position: absolute;
  left: 0px;
  top: 0px;
  /* border: 1px solid red; */
  background-color: rgba(255, 255, 0, 0.25);
  pointer-events: none;
  box-sizing: border-box;
}

.p-filter-hovered-grid{
  width: 10.5px;
  height: 10.5px;
  border: 1px solid red;
  pointer-events: none;
  box-sizing: border-box;
}


.input-pooled-image{
  box-shadow: 4px 4px 10px grey;
  /* border: 1px solid black; */
 
}

.p-result-filter-hovered-area{
  width: 10.5px;
  height: 10.5px;
  position: absolute;
  left: 0px;
  top: 0px;
  border: 1px solid red;
  background-color: rgba(255, 255, 0, 0.25);
  pointer-events: none;
  box-sizing: border-box;

}

/* Simulation Pooling Practice */
.s-pooling-result-container{

  padding: 10px;
}

.s-pooling-result-vis-container{
  display: flex;
  align-items: center;
}

.s-pooling-image{
  margin: 5px;
  border: 1px solid black;
}
.s-pooled-image{
  margin: 5px;
  border: 1px solid black;
}

.practice-result-selection-row{
  display: flex;
}

.practice-result-box{
  width: 30px;
  height: 30px;
  border: 1px solid black;
}

.practice-result-slider{
  width: 255px;
}

.selected-box{
  border: 1px solid red;
}
/* Average Pooling Practice */

.pooling-practice-container{
  display: flex;
}
.avgPooling-process-area{
  width: 335px;
}

.avgPooing-img-row-container{
  display: flex;
}

.avg-pooling-pixels-container{
  width: 25px;
  height: 25px;

}

.avg-pooling-pixels{
  width: 25px;
  height: 25px;
  border: 0.25px solid black;
}
.avgPooing-process-row-container{
  display: flex;
}

.avg-pooling-process-pixels-container{
  width: 25px;
  height: 25px;
  border: 1px solid black
}
.division-vis{
  width: 125px;
}

.avg-pooled-r-ans{
  width: 25px;
  height: 25px;
  /* border: 1px solid black; */
}



/* Max Pooling Practice */

.max-pooling-area-container{
  border: 1px solid black;
}
.max-pooling-outer-row-container{
  display: flex;
}


.max-pooling-area-row-container{
  display: flex;
}

.max-pooling-pixels{
  width: 25px;
  height: 25px;
  /* border: 1px solid black; */
}

.max-pooling-pixels:hover {
  transform: scale(1.1); 
  transition: transform 0.3s ease;
  border: 1px solid rgb(255, 0, 0); 
}



.max-pooled-r-ans{
  width: 25px;
  height: 25px;
  /* border: 1px solid black; */
}
`, "",{"version":3,"sources":["webpack://./src/pages/ch4/Pooling.css"],"names":[],"mappings":";AACA,sBAAsB;;AAEtB;EACE;;GAEC;EACD,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,2BAAsB;EAAtB,sBAAsB;EACtB,aAAa;EACb,4BAA4B;EAC5B,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,4CAA4C;;AAE9C;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,aAAa;EACb,oCAAoC;EACpC,kCAAkC;EAClC,WAAW;;AAEb;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,mDAAmD;EACnD,kCAAkC;EAClC,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,uBAAuB;;AAEzB;;AAEA;EACE,WAAW;EACX,wBAAmB;EAAnB,mBAAmB;;AAErB;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA,wBAAwB;;AAExB;EACE,2BAAsB;EAAtB,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,2BAA2B;EAC3B,yCAAyC;EACzC,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;AACxB;;;AAGA;EACE,6BAA6B;EAC7B,6BAA6B;;AAE/B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,qBAAqB;EACrB,yCAAyC;EACzC,oBAAoB;EACpB,sBAAsB;;AAExB;;AAEA,gCAAgC;AAChC;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;AACA,6BAA6B;;AAE7B;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;;AAEd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;AACF;AACA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;;;AAIA,yBAAyB;;AAEzB;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,gCAAgC;AAClC;;;;AAIA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B","sourcesContent":["\n/* Entire Simulation */\n\n[draggable=\"true\"] {\n  /*\n   To prevent user selecting inside the drag source\n  */\n  user-select: none;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n}\n\n.s-color-map{\n  width: calc(255px * 2);\n  height: 20px;\n  box-shadow: 4px 4px 10px #00000042;\n}\n\n.p-simulation-container{\n  min-width: fit-content;\n  display: flex;\n  /* flex-direction: column; */\n  justify-content: center;\n  align-items: center;\n  padding: 2rem;\n  margin: 10px 2rem;\n  background-color: rgba(124, 124, 124, 0.158);\n\n}\n\n.p-valid-ans{\n  border: 2px solid green;\n}\n.p-invalid-ans{\n  border: 2px solid red;\n}\n\n/* Control Panel */\n.pooling-control-panel-container{\n  min-width: 400px;\n  padding: 10px;\n  background-color: rgb(255, 249, 249);\n  box-shadow: 2px 2px 10px #00000042;\n  margin: 5px;\n\n}\n.pooling-simulation-title{\n  background-color: #FFB800;\n  border-radius: 5px;\n  padding: 2px;\n  margin: 5px;\n  text-shadow: 3px 3px 3px rgba(226, 223, 223, 0.747);\n  box-shadow: 4px 4px 10px #00000042;\n  font-size: 20px;\n  display: flex;\n  justify-content: center;\n  font-weight: bolder;\n}\n\n.all-select-container{\n  display: flex;\n  justify-content: center;\n  width: calc(100% - 10px);\n  margin: 5px;\n  padding: 5px;\n  background-color: white;\n\n}\n\n.pooling-section{\n  width: 100%;\n  height: fit-content;\n\n}\n\n.select-container{\n  width: 100%;\n  margin: 5px;\n}\n\n.p-image-option{\n  width: 80px;\n  height: 80px;\n  margin-right: 5px;\n  box-shadow: 2px 2px 5px grey;\n}\n\n.p-image-option:hover{\n  transform: scale(1.1);\n  transition: transform 0.3s ease;\n  cursor: pointer;\n}\n\n/* Input Pooling Image */\n\n.pooling-result-container{\n  min-width: fit-content;\n  padding: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.input-pooling-image{\n  box-shadow: 4px 4px 10px grey;\n  /* border: 1px solid black; */\n}\n\n.p-filter-hovered-area{\n  width: 21.0px;\n  height: 21.0px;\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  /* border: 1px solid red; */\n  background-color: rgba(255, 255, 0, 0.25);\n  pointer-events: none;\n  box-sizing: border-box;\n}\n\n.p-filter-hovered-grid{\n  width: 10.5px;\n  height: 10.5px;\n  border: 1px solid red;\n  pointer-events: none;\n  box-sizing: border-box;\n}\n\n\n.input-pooled-image{\n  box-shadow: 4px 4px 10px grey;\n  /* border: 1px solid black; */\n \n}\n\n.p-result-filter-hovered-area{\n  width: 10.5px;\n  height: 10.5px;\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  border: 1px solid red;\n  background-color: rgba(255, 255, 0, 0.25);\n  pointer-events: none;\n  box-sizing: border-box;\n\n}\n\n/* Simulation Pooling Practice */\n.s-pooling-result-container{\n\n  padding: 10px;\n}\n\n.s-pooling-result-vis-container{\n  display: flex;\n  align-items: center;\n}\n\n.s-pooling-image{\n  margin: 5px;\n  border: 1px solid black;\n}\n.s-pooled-image{\n  margin: 5px;\n  border: 1px solid black;\n}\n\n.practice-result-selection-row{\n  display: flex;\n}\n\n.practice-result-box{\n  width: 30px;\n  height: 30px;\n  border: 1px solid black;\n}\n\n.practice-result-slider{\n  width: 255px;\n}\n\n.selected-box{\n  border: 1px solid red;\n}\n/* Average Pooling Practice */\n\n.pooling-practice-container{\n  display: flex;\n}\n.avgPooling-process-area{\n  width: 335px;\n}\n\n.avgPooing-img-row-container{\n  display: flex;\n}\n\n.avg-pooling-pixels-container{\n  width: 25px;\n  height: 25px;\n\n}\n\n.avg-pooling-pixels{\n  width: 25px;\n  height: 25px;\n  border: 0.25px solid black;\n}\n.avgPooing-process-row-container{\n  display: flex;\n}\n\n.avg-pooling-process-pixels-container{\n  width: 25px;\n  height: 25px;\n  border: 1px solid black\n}\n.division-vis{\n  width: 125px;\n}\n\n.avg-pooled-r-ans{\n  width: 25px;\n  height: 25px;\n  /* border: 1px solid black; */\n}\n\n\n\n/* Max Pooling Practice */\n\n.max-pooling-area-container{\n  border: 1px solid black;\n}\n.max-pooling-outer-row-container{\n  display: flex;\n}\n\n\n.max-pooling-area-row-container{\n  display: flex;\n}\n\n.max-pooling-pixels{\n  width: 25px;\n  height: 25px;\n  /* border: 1px solid black; */\n}\n\n.max-pooling-pixels:hover {\n  transform: scale(1.1); \n  transition: transform 0.3s ease;\n  border: 1px solid rgb(255, 0, 0); \n}\n\n\n\n.max-pooled-r-ans{\n  width: 25px;\n  height: 25px;\n  /* border: 1px solid black; */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
